var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDlpNotVerifiedYet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3828 8.39453C10.6953 8.94141 10.3047 9.625 9.66016 9.625H1.32031C0.675781 9.625 0.285156 8.94141 0.597656 8.39453L4.77734 1.28516C5.08984 0.738281 5.89062 0.738281 6.22266 1.28516L10.3828 8.39453ZM5.03125 3.53125V6.03125C5.03125 6.30469 5.26562 6.5 5.5 6.5C5.75391 6.5 5.96875 6.30469 5.96875 6.03125V3.53125C5.96875 3.27734 5.75391 3.0625 5.5 3.0625C5.22656 3.0625 5.03125 3.27734 5.03125 3.53125ZM5.5 8.375C5.83203 8.375 6.10547 8.10156 6.10547 7.76953C6.10547 7.4375 5.83203 7.16406 5.5 7.16406C5.14844 7.16406 4.875 7.4375 4.875 7.76953C4.875 8.10156 5.14844 8.375 5.5 8.375Z",
    fill: "#FB306D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpNotVerifiedYet);
export default __webpack_public_path__ + "static/media/DlpNotVerifiedYet.6646613bcc345e0e85dec546f97ae03e.svg";
export { ForwardRef as ReactComponent };